var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03056 4.08889C4.12968 4.0818 4.22356 4.0417 4.29722 3.975L7.85266 0.775097C7.89608 0.736068 7.93138 0.68887 7.95655 0.636197C7.98173 0.583525 7.99627 0.526409 7.99937 0.468112C8.00247 0.409816 7.99406 0.351479 7.97461 0.296435C7.95516 0.24139 7.92506 0.190716 7.88603 0.147305C7.847 0.103894 7.79979 0.0685964 7.74712 0.0434288C7.69444 0.0182612 7.63732 0.00371605 7.57903 0.000623969C7.52073 -0.00246811 7.46239 0.00595347 7.40735 0.0254077C7.35231 0.044862 7.30164 0.0749679 7.25823 0.114006L4 3.04725L0.741771 0.114006C0.698364 0.0749679 0.647696 0.044862 0.592654 0.0254077C0.537612 0.00595347 0.479277 -0.00246811 0.42098 0.000623969C0.362683 0.00371605 0.305562 0.0182612 0.252886 0.0434288C0.200211 0.0685964 0.153003 0.103894 0.113969 0.147305C0.0749359 0.190716 0.0448346 0.24139 0.0253868 0.296435C0.00593901 0.351479 -0.00247288 0.409816 0.000626087 0.468112C0.00372505 0.526409 0.0182791 0.583525 0.0434527 0.636197C0.0686264 0.68887 0.10393 0.736068 0.147345 0.775097L3.70279 3.975C3.74699 4.01499 3.79879 4.04568 3.8551 4.06525C3.91141 4.08481 3.97108 4.09285 4.03056 4.08889Z",
    fill: "#2B96DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.fe8a56df27426de3526c8e9884871878.svg";
export { ForwardRef as ReactComponent };